import { Link } from "react-router-dom";
import { Paper, ScrollArea, Button, ThemeIcon, Center, Loader, Tabs, useMantineTheme, Stack, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconPlus, IconTrash, IconUsers } from "@tabler/icons-react";
import cx from "clsx";

import { ListTeamDto } from "../../models/team.models";
import { useFilteredTeams } from "../../functions/team-filter.hooks";
import { useSearch } from "../../functions/SearchBox.hook";
import { NoSearchResults } from "../Shared/NoSearchResults";
import classes from './TeamList.module.css';

interface TeamListProps {
	teams?: ListTeamDto[] | undefined;
	isLoading?: boolean;
	selectedTeam?: ListTeamDto | null;
	setSelectedTeam?: (team: ListTeamDto | null) => void;
	setSelectedTab?: (tab: string | null) => void;
}
export const TeamList = ({ teams, isLoading, selectedTeam, setSelectedTeam, setSelectedTab }: TeamListProps) => {
	const theme = useMantineTheme();
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`, true);
	const { query, setQuery } = useSearch();
	const { filteredTeams, showNoResults } = useFilteredTeams(teams || []);

	if (isLoading) return <Paper withBorder p={0} radius="md" style={{ overflow: 'hidden' }}>
			<ScrollArea type={isMobile ? "never" : "scroll"} style={{ height: isMobile ? 'unset' : 'calc(100vh - 160px)', minHeight: isMobile ? 'calc(100vh - 150px)' : 'calc(100vh - 160px)' }} >
				<Center>
					<Loader size="sm" mt="lg" />
				</Center>
			</ScrollArea>
		</Paper>

	const handleTeamSelect = (e: React.MouseEvent<HTMLAnchorElement>, team: ListTeamDto): void => {
		e.preventDefault();
		setSelectedTeam?.(team);
	}

	return <>
		<Paper withBorder p={0} radius="md" style={{ overflow: 'hidden' }}>
			<ScrollArea type={isMobile ? "never" : "hover"} style={{ height: isMobile ? 'unset' : 'calc(100vh - 160px)', minHeight: isMobile ? 'calc(100vh - 150px)' : 'calc(100vh - 160px)' }} >
				<Tabs value="teams" onChange={setSelectedTab} defaultValue="teams" radius="md" className={classes.tabs}>
					<Tabs.List grow>
						<Tabs.Tab value="users">Users</Tabs.Tab>
						<Tabs.Tab value="teams">Teams</Tabs.Tab>
					</Tabs.List>
					<Tabs.Panel value="teams">		
						{filteredTeams?.map(team => (
							<Button key={team.TeamId}
								component="a"
								href={`/teams/${team.TeamId}`}
								onClick={(e) => handleTeamSelect(e, team)}
								className={cx(classes['user-list-item'], { [classes['selected-item']]: selectedTeam?.TeamId === team.TeamId })}
								leftSection={
									<ThemeIcon radius="xl"
										color={team.Deleted ? "red" : team.Colour}
										size="xl"
										style={{ border: `1px solid var(--mantine-color-default-border)` }}
										variant="light"
									>
										{!team.Deleted ? <IconUsers size={24} /> : <IconTrash size={24} />}
									</ThemeIcon>
								}
							>
								{team.Name}
							</Button>
						))}
						{showNoResults && <NoSearchResults searchType="teams" query={query} setQuery={setQuery} />}
						{teams?.length === 0 && <>
							<Stack align="center" justify="center" mt="xl" px="sm">
								<ThemeIcon size={100} radius={100} variant="light" color="gray">
									<IconUsers size={60} />
								</ThemeIcon>
								<Text style={{ textAlign: 'center' }} lineClamp={1} c="dimmed">No teams have been created yet.</Text>
							</Stack>
						</>}
					</Tabs.Panel>
				</Tabs>
			</ScrollArea>
		</Paper>
	</>
}
